/** Explicit integer Y-axis ticks so Recharts grid lines align with labels. */
export function buildCountYAxisScale(values: number[]): {
  yAxisMax: number;
  yAxisTicks: number[];
} {
  const chartMax = Math.max(0, ...values);
  const yAxisMax = Math.max(1, Math.ceil(chartMax));

  if (yAxisMax <= 12) {
    return {
      yAxisMax,
      yAxisTicks: Array.from({ length: yAxisMax + 1 }, (_, index) => index),
    };
  }

  const targetTickCount = 6;
  const rawStep = yAxisMax / (targetTickCount - 1);
  const magnitude = 10 ** Math.floor(Math.log10(Math.max(rawStep, 1)));
  const normalized = rawStep / magnitude;
  const niceNormalized = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10;
  const step = niceNormalized * magnitude;

  const yAxisTicks: number[] = [];
  for (let value = 0; value <= yAxisMax; value += step) {
    yAxisTicks.push(value);
  }
  if (yAxisTicks[yAxisTicks.length - 1] !== yAxisMax) {
    yAxisTicks.push(yAxisMax);
  }
  return { yAxisMax, yAxisTicks };
}

export function buildCountYAxisScaleForChart(
  dataValues: number[],
  goalValues: number[] = []
): {
  yAxisMax: number;
  yAxisTicks: number[];
} {
  const rawMax = Math.max(0, ...dataValues, ...goalValues);
  const paddedMax =
    goalValues.length > 0 && rawMax > 0
      ? Math.max(rawMax + 1, Math.ceil(rawMax * 1.1))
      : rawMax;
  return buildCountYAxisScale([paddedMax]);
}

export function buildChartYDomain(
  dataValues: number[],
  goalValues: number[] = []
): [number, number] {
  const rawMax = Math.max(0, ...dataValues, ...goalValues);
  if (goalValues.length > 0 && rawMax > 0) {
    return [0, Math.max(rawMax + 1, Math.ceil(rawMax * 1.1))];
  }
  return [0, Math.max(rawMax, 1)];
}
